import { render } from "./BriefBar.vue?vue&type=template&id=601a67a5"
import script from "./BriefBar.vue?vue&type=script&lang=js"
export * from "./BriefBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__